<template>
  <div class="packageOrder">
    <div class="header">
      <el-tabs :value="tabPaneValue" @tab-click="tabPaneClick">
        <el-tab-pane label="包装工单" name="first">
          <span class="activeLink">包装工单</span>
          <div class="btnBox">            
            <div class="searchBtnBox" style="margin-right:15px">
              <el-tooltip class="item" content="只看我的工单" placement="bottom" :open-delay="300">
                <el-checkbox v-model="searchConditionForm.onlyMy" @change="onlyMyChange">我的工单</el-checkbox>
              </el-tooltip>
            </div>
            <div class="searchBtnBox" v-if="isMoreSearch">
              <el-tooltip
                class="item"
                content="清除查询条件"
                placement="bottom"
                :open-delay="300"
              >
                <el-button
                  icon="iconfont icon-qingkong"
                  size="small"
                  class="cleanBox"
                  @click="onClear"
                ></el-button>
              </el-tooltip>
              <el-button
                type="primary"
                icon="el-icon-search"
                size="small"
                @click="onSearch"
                >查询</el-button
              >
            </div>
            <el-button
              type="primary"
              icon="el-icon-plus"
              size="small"
              @click="addNewBtn"
              >新建</el-button
            >
            <el-tooltip
              class="item"
              content="查询条件"
              placement="bottom"
              :open-delay="300"
            >
              <el-button
                class="btn_more"
                :class="{ activeUserMore: isMoreSearch }"
                size="small"
                icon="el-icon-d-arrow-right"
                @click="moreSearchBtn"
              ></el-button>
            </el-tooltip>
          </div>
        </el-tab-pane>
        <el-tab-pane
          v-for="(item, index) in tabPaneList"
          :key="item.id"
          :label="item.orderNumber"
          :name="item.id"
        >
          <span slot="label">
            {{ item.orderNumber }}
            <i
              class="el-icon-circle-close"
              @click.stop="closeTabPane(index)"
            ></i>
          </span>
          <span
            class="childTabs"
            :class="{ activeLink: cutDetail == 'detail' }"
            @click="cutDetailChange('detail')"
            >工单详情</span
          >
          <span
            class="childTabs"
            :class="{ activeLink: cutDetail == 'devices' }"
            @click="cutDetailChange('devices')"
            >产品列表</span
          >
          <span
            class="childTabs"
            :class="{ activeLink: cutDetail == 'status' }"
            @click="cutDetailChange('status')"
            >生产状态</span
          >
          <span
            class="childTabs"
            :class="{ activeLink: cutDetail == 'process' }"
            @click="cutDetailChange('process')"
            >生产工序</span
          >
          <span
            class="childTabs"
            :class="{ activeLink: cutDetail == 'QcCheckList' }"
            @click="cutDetailChange('QcCheckList')"
            >检验单</span
          >
          <span
            class="childTabs"
            :class="{ activeLink: cutDetail == 'proLog' }"
            @click="cutDetailChange('proLog')"
            >生产日志</span
          >
          <div class="btnBox">
            <el-button v-if="cutDetail == 'detail' && detailData.status && detailData.status.code=='READY'" type="primary" size="small" @click="detailStatusBtn">开始生产</el-button>
            <el-button v-if="cutDetail == 'status'" type="primary" size="small" @click="removeUnpacked">移除未封箱</el-button>
            <el-button v-if="(cutDetail == 'detail' || cutDetail == 'status') && detailData.status && detailData.status.code=='PRODUCTION'" type="primary" size="small" @click="pauseOrder($event, detailData, true)">暂停</el-button>
            <el-button v-if="(cutDetail == 'detail' || cutDetail == 'status') && detailData.status && detailData.status.code=='PRODUCTION'" type="primary" size="small" @click="detailStatusBtn">结单</el-button>
          </div>
          <div class="btnBox" v-if="cutDetail == 'devices'">
            <div class="searchBtnBox" v-if="isMoreSearch">
              <el-button type="primary" size="small" @click="unbindDialog('移除SN')">
                移除SN
              </el-button>
              <el-button type="primary" size="small" @click="unbindDialog('解绑内箱')">
                解绑内箱
              </el-button>
              <el-button type="primary" size="small" @click="unbindDialog('解绑外箱')">
                解绑外箱
              </el-button>
              <el-button type="primary" size="small" @click="rework">
                返工
              </el-button>
              <el-tooltip
                class="item"
                content="清除查询条件"
                placement="bottom"
                :open-delay="300"
              >
                <el-button
                  icon="iconfont icon-qingkong"
                  size="small"
                  class="cleanBox"
                  @click="onClear"
                ></el-button>
              </el-tooltip>
              <el-button
                type="primary"
                icon="el-icon-download"
                size="small"
                @click="tableExport"
                >导出</el-button
              >
              <el-dropdown
                split-button
                type="primary"
                size="small"
                class="searchBox"  @click="onSearch(false)"
                trigger="click"
              >
                查询
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item @click.native="onSearch(true)"
                    >模糊查询</el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown>
            </div>
            <el-tooltip
              class="item"
              content="查询条件"
              placement="bottom"
              :open-delay="300"
            >
              <el-button
                class="btn_more"
                :class="{ activeUserMore: isMoreSearch }"
                size="small"
                icon="el-icon-d-arrow-right"
                @click="moreSearchBtn"
              ></el-button>
            </el-tooltip>
          </div>
          <div class="btnBox" v-else-if="cutDetail == 'process'">
            <el-button
              type="primary"
              icon="el-icon-plus"
              size="small"
              @click="addProcess"
              >添加</el-button
            >
          </div>
          <div class="btnBox" v-else-if="cutDetail == 'proLog'">
            <div class="searchBtnBox" v-if="isMoreSearch">
              <el-button @click="onSearch(true)" class="downIcon" type="primary" size="small">导出</el-button>
              <el-tooltip
                class="item"
                content="清除查询条件"
                placement="bottom"
                :open-delay="300"
              >
                <el-button
                  icon="iconfont icon-qingkong"
                  size="small"
                  class="cleanBox"
                  @click="onClear"
                ></el-button>
              </el-tooltip>
              <el-button
                type="primary"
                icon="el-icon-search"
                size="small"
                @click="onSearch(false)"
                >查询</el-button
              >
            </div>
            <el-tooltip
              class="item"
              content="查询条件"
              placement="bottom"
              :open-delay="300"
            >
              <el-button
                class="btn_more"
                :class="{ activeUserMore: isMoreSearch }"
                size="small"
                icon="el-icon-d-arrow-right"
                @click="moreSearchBtn"
                style="margin-left: 0px"
              ></el-button>
            </el-tooltip>
          </div>
        </el-tab-pane>
      </el-tabs>
      <!-- 包装工单 查询条件 -->
      <el-form
        :inline="true"
        :model="searchConditionForm"
        class="demo-form-inline"
        v-if="isMoreSearch && tabPaneValue == 'first'"
      >
        <div class="searchConditionBox">
          <el-form-item label="包装单号" size="small">
            <el-input
              v-model="searchConditionForm.orderNumber"
              placeholder="包装工单号"
              clearable
              @keyup.enter.native="getCartonOrderSearch()"
            ></el-input>
          </el-form-item>
          <el-form-item label="SAP单号" size="small">
            <el-input
              v-model="searchConditionForm.sapOrderNumber"
              placeholder="SAP生产单号"
              clearable
              @keyup.enter.native="getCartonOrderSearch()"
            ></el-input>
          </el-form-item>
          <el-form-item label="成品编码" size="small">
            <el-input
              v-model="searchConditionForm.itemCode"
              placeholder="成品编码"
              clearable
              @keyup.enter.native="getCartonOrderSearch()"
            ></el-input>
          </el-form-item>
          <el-form-item label="客户" size="small">
            <el-select
              v-model="searchConditionForm.customerId"
              placeholder="选择客户名称"
              filterable
              clearable
              @change="searchCustomerChange"
            >
              <el-option
                v-for="(item, index) in pullDownData.customerList"
                :key="index"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="组装工单" size="small">
            <el-select v-model="searchConditionForm.productionOrderId"
              placeholder="选择组装工单" filterable clearable class="hiddenSelectDropdown" popper-append-to-body="false"
              @visible-change="selectVisible($event, 'productionOrder', '组装工单', 'searchConditionForm')">
              <el-option v-for="(item, index) in pullDownData.productionOrderList"
                :key="index" :label="item.orderNumber" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="销售订单" size="small">
            <el-select v-model="searchConditionForm.customerOrderId"
              placeholder="选择销售订单" filterable clearable class="hiddenSelectDropdown" popper-append-to-body="false"
              @visible-change="selectVisible($event, 'customerOrder', '销售订单', 'searchConditionForm')">
              <el-option v-for="(item, index) in pullDownData.customerOrderList"
                :key="index" :label="item.orderNumber" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="工单状态" size="small">
            <el-select
              v-model="searchConditionForm.status"
              placeholder="选择工单状态"
              filterable
              clearable
              multiple
              collapse-tags
            >
              <el-option
                v-for="(item, index) in pullDownData.orderStatusList"
                :key="index"
                :label="item.title"
                :value="item.code"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="所有者" size="small">
            <el-select
              v-model="searchConditionForm.userId"
              placeholder="选择工单所有者"
              filterable
              clearable
              class="hiddenSelectDropdown"
              :popper-append-to-body="false"
              @visible-change="
                selectVisible($event, 'user', '员工选择', 'searchConditionForm')
              "
            >
              <el-option
                v-for="(item, index) in pullDownData.userList"
                :key="index"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </div>
      </el-form>
      <!-- 产品列表 查询条件 -->
      <el-form
        :inline="true"
        :model="devicesSearchForm"
        class="demo-form-inline"
        v-else-if="
          isMoreSearch && tabPaneValue != 'first' && cutDetail == 'devices'
        "
        key="devices"
      >
        <div class="searchConditionBox">
          <el-form-item label="产品SN" size="small">
            <el-input
              v-model="devicesSearchForm.sn"
              placeholder="SN"
              clearable
              @keyup.enter.native="$refs.devicesPage.getCartonOrderDevices()"
            ></el-input>
          </el-form-item>
          <el-form-item label="包装类型" size="small">
            <el-select
              v-model="devicesSearchForm.cartonType"
              placeholder="选择包装类型"
              filterable
              clearable
              @change="cartonTypeChange"
            >
              <el-option
                v-for="(item, index) in pullDownData.devicesCartonTypeList"
                :key="index"
                :label="item.title"
                :value="item.code"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="索引号" size="small">
            <el-input
              v-model="devicesSearchForm.ctnIndex"
              placeholder="箱号索引号"
              clearable
              @keyup.enter.native="$refs.devicesPage.getCartonOrderDevices()"
              :disabled="!devicesSearchForm.cartonType"
            ></el-input>
          </el-form-item>
          <el-form-item label="系列号" size="small">
            <el-input
              v-model="devicesSearchForm.ctnSn"
              placeholder="箱号系列号"
              clearable
              @keyup.enter.native="$refs.devicesPage.getCartonOrderDevices()"
              :disabled="!devicesSearchForm.cartonType"
            ></el-input>
          </el-form-item>
          <el-form-item label="组装工单" size="small">
            <el-select
              v-model="devicesSearchForm.productionOrderId"
              placeholder="选择组装工单"
              filterable
              clearable
            >
              <el-option
                v-for="(item, index) in pullDownData.devicesProductionList"
                :key="index"
                :label="item.orderNumber"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="当前工序" size="small">
            <el-select
              v-model="devicesSearchForm.workStationId"
              placeholder="设备所在的工序"
              multiple
              collapse-tags
              filterable
              clearable
              @change="workStationChange"
            >
              <el-option
                v-for="(item, index) in pullDownData.productionOrderStatusList"
                :key="index"
                :label="item.workStation.name"
                :value="item.workStation.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </div>
      </el-form>
      <!-- 检验单 查询条件 -->
      <el-form
        :inline="true"
        :model="inspectionForm"
        class="demo-form-inline"
        v-else-if="
          isMoreSearch && tabPaneValue != 'first' && cutDetail == 'QcCheckList'
        "
        key="inspections"
      >
        <div class="searchConditionBox">
          <el-form-item label="检验单号" size="small">
            <el-input v-model="inspectionForm.orderNumber" placeholder="送检单号" clearable
              @keyup.enter.native="getQcCheckListSearch()" />
          </el-form-item>
          <el-form-item label="抽检批次" size="small">
            <el-input v-model="inspectionForm.partLot" placeholder="抽检批次" clearable
              @keyup.enter.native="getQcCheckListSearch()" />
          </el-form-item>
          <el-form-item label="送检时间" size="small">
            <el-date-picker
              v-model="inspectionForm.startDateTime"
              type="datetime"
              placeholder="送检开始时间"
              value-format="yyyy-MM-dd HH:mm:ss"
              @change="startDateChange('searchConditionForm')"
              :picker-options="$store.state.pickerOptions"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="结束时间" size="small">
            <el-date-picker
              v-model="inspectionForm.endDateTime"
              type="datetime"
              placeholder="送检结束时间"
              @change="endDateChange('searchConditionForm')"
              value-format="yyyy-MM-dd HH:mm:ss"
              :picker-options="$store.state.pickerOptions"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="客户" size="small">
            <el-select
              v-model="inspectionForm.customerId"
              placeholder="选择客户名称"
              filterable
              clearable
            >
              <el-option
                v-for="(item, index) in pullDownData.customerList"
                :key="index"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="所有者" size="small">
            <el-select
              v-model="inspectionForm.userId"
              placeholder="选择工单所有者"
              filterable
              clearable
              class="hiddenSelectDropdown"
              :popper-append-to-body="false"
              @visible-change="
                selectVisible($event, 'user', '员工选择', 'inspectionForm')
              "
            >
              <el-option
                v-for="(item, index) in pullDownData.userList"
                :key="index"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </div>
      </el-form>
      <!-- 生产日志 查询条件 -->
      <el-form
        :inline="true"
        :model="proLogForm"
        class="demo-form-inline"
        v-else-if="
          isMoreSearch && tabPaneValue != 'first' && cutDetail == 'proLog'
        "
        key="proLog"
      >
        <div class="searchConditionBox">
          <el-form-item label="请求ID" size="small">
            <el-input
              :value="proLogForm.id"
              @input="idInputChange($event, 'proLogForm')"
              placeholder="Request ID"
              clearable
              @keyup.enter.native="$refs.ProLogPage.getFactoryLogSearch()"
            ></el-input>
          </el-form-item>
          <el-form-item label="Key" size="small">
            <el-input
              v-model="proLogForm.key"
              placeholder="输入Key"
              clearable
              @keyup.enter.native="$refs.ProLogPage.getFactoryLogSearch()"
            ></el-input>
          </el-form-item>
          <el-form-item label="员工" size="small">
            <el-select
              v-model="proLogForm.userId"
              placeholder="选择员工"
              filterable
              clearable
              class="hiddenSelectDropdown"
              :popper-append-to-body="false"
              @visible-change="
                selectVisible($event, 'user', '员工选择', 'proLogForm')
              "
            >
              <el-option
                v-for="(item, index) in pullDownData.userList"
                :key="index"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="线体" size="small">
            <el-cascader
              :options="pullDownData.factoryOrgData"
              :props="{
                checkStrictly: true,
                emitPath: false,
                label: 'name',
                value: 'id',
              }"
              :show-all-levels="false"
              v-model="proLogForm.organizationId"
              @change="cascaderChange($event, 'factoryOrgCascader')"
              ref="factoryOrgCascader"
              placeholder="选择所在线体"
              clearable
            ></el-cascader>
          </el-form-item>
          <el-form-item label="工序" size="small">
            <el-select
              v-model="proLogForm.workStationId"
              filterable multiple collapse-tags
              placeholder="选择工序"
              clearable
            >
              <el-option
                v-for="(item, index) in pullDownData.cartonSopList"
                :key="index"
                :label="item.workStation.name"
                :value="item.workStation.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="错误代码" size="small">
            <!-- <el-input
              v-model="proLogForm.errorCode"
              placeholder="错误代码"
              clearable
            ></el-input> -->
            <el-select
              v-model="proLogForm.errorCode"
              filterable
              allow-create
              default-first-option
              placeholder="错误代码"
              clearable
            >
              <el-option label="所有错误" value="-99998"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="开始时间" size="small">
            <el-date-picker
              v-model="proLogForm.startDateTime"
              type="datetime"
              placeholder="开始时间"
              value-format="yyyy-MM-dd HH:mm:ss"
              clearable
              @change="startDateChange('proLogForm')"
              :picker-options="$store.state.pickerOptions"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="结束时间" size="small">
            <el-date-picker
              v-model="proLogForm.endDateTime"
              type="datetime"
              placeholder="结束时间"
              value-format="yyyy-MM-dd HH:mm:ss"
              clearable
              @change="endDateChange('proLogForm')"
              :picker-options="$store.state.pickerOptions"
            ></el-date-picker>
          </el-form-item>
        </div>
      </el-form>
      <!-- 温馨提示 -->
      <div
        class="tips tipsBox"
        v-show="tabPaneValue != 'first' && cutDetail == 'process' && isShowTips"
      >
        <span class="title">温馨提示：</span>
        <span class="text"
          >如果出现“模版缺失”请确认标签模版中是否有产品型号对应的模版，并检查组装工单的【成品编码】是否正确。</span
        >
        <i class="el-icon-close close" @click="closeTips"></i>
      </div>
    </div>
    <div class="contentBox">
      <!-- 包装工单列表表格 -->
      <div class="rightContent" v-if="tabPaneValue == 'first'">
        <el-table
          stripe
          :data="tableData"
          border
          style="width: 100%"
          height="100%"
          size="mini"
          @sort-change="sortChange"
        >
          <el-table-column
            type="index"
            :width="pagination.endIndex >= 1000 ? 80 : 50"
            align="center"
            :index="pagination.beginIndex"
          ></el-table-column>
          <el-table-column
            prop="orderNumber"
            label="包装单号"
            min-width="120px"
            show-overflow-tooltip
            sortable="custom"
            align="center"
          >
            <template slot-scope="scope">
              <span class="allowSkip" @click="clickAllowSkip(scope.row)">{{
                scope.row.orderNumber
              }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="sapOrderNumber" label="SAP单号"
            min-width="120px" show-overflow-tooltip sortable="custom" align="center">
            <template slot-scope="scope">              
              <span v-if="scope.row.sapOrderNumber">{{ scope.row.sapOrderNumber }}</span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="itemCode"
            label="成品编码"
            min-width="125px"
            align="center"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span v-if="scope.row.itemCode">{{
                scope.row.itemCode
              }}</span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column prop="products" label="产品型号" align="center"
            min-width="95px">
            <template slot-scope="scope">
              <el-tooltip v-if="scope.row.products && scope.row.products.length>0" class="item" effect="dark" placement="top" :open-delay="300"
                :content="scope.row.products">
                <div class="textOverflow">{{scope.row.products }} </div>
              </el-tooltip>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="quantity"
            sortable="custom"
            label="数量"
            align="center"
            width="95px"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="customerId"
            label="客户"
            min-width="120px"
            align="center"
            show-overflow-tooltip
            sortable="custom"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.customer">{{
                scope.row.customer.name
              }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="inner" label="内箱规格" align="center"
            width="90px">
            <template slot-scope="scope">
              <el-tooltip v-if="scope.row.inner" class="item" effect="dark" placement="top" :open-delay="300"
                :content="!scope.row.inner ? '' : (scope.row.inner.pack + '/箱，' + scope.row.inner.scale.title + '，已完成：'+scope.row.inner.done)">
                <div class="textOverflow">{{scope.row.inner.pack+'/箱' }} </div>
              </el-tooltip>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column prop="outer" label="外箱规格" align="center"
            width="90px">
            <template slot-scope="scope">
              <el-tooltip v-if="scope.row.outer" class="item" effect="dark" placement="top" :open-delay="300"
                :content="!scope.row.outer ? '' : (scope.row.outer.pack + '/箱，' + scope.row.outer.scale.title + '，已完成：'+scope.row.outer.done)">
                <div class="textOverflow">{{scope.row.outer.pack+'/箱'}}</div>
              </el-tooltip>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column prop="pallet" label="栈板规格" align="center"
            width="90px">
            <template slot-scope="scope">
              <el-tooltip v-if="scope.row.pallet" class="item" effect="dark" placement="top" :open-delay="300"
                :content="!scope.row.pallet ? '' : (scope.row.pallet.pack +'/栈板，已完成：'+scope.row.pallet.done)">
                <div class="textOverflow">{{scope.row.pallet.pack+'/栈板'}}</div>
              </el-tooltip>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column prop="createUser" label="所有者" align="center" show-overflow-tooltip
            width="95px">
            <template slot-scope="scope">
              <span v-if="scope.row.createUser">
                {{ scope.row.createUser.name }} ({{ scope.row.createUser.employeeNum }})
              </span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column class-name="operation" width="95px" label="状态" align="center"
            prop="status"
            sortable="custom">
            <template slot-scope="scope">
              <el-tooltip v-if="scope.row.timeOut  && scope.row.timeOut>0"
                class="item expire"
                effect="dark"
                :content="'已逾期【'+scope.row.timeOut +' 天】未关闭工单，请及时关闭工单！'"
                placement="top"
                :open-delay="300"
              >
                <span class="textOverflow">
                  <i class="iconfont icon-yiguoqi"></i>{{ scope.row.status.title }}
                </span>
              </el-tooltip>
              <el-tooltip v-else class="item" effect="dark" placement="top" :open-delay="300"
                :content="scope.row.status.title">
                <span class="textOverflow">{{ scope.row.status.title }}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column class-name="operation" width="95px" label="操作" align="center">
            <template slot-scope="scope">
              <el-tooltip
                v-if="scope.row.status && scope.row.status.code=='PRODUCTION'"
                class="item"
                effect="dark"
                content="暂停"
                placement="top"
                :open-delay="300"
              >
                <i @click="pauseOrder($event, scope.row)" class="iconfont icon-pause"></i>
              </el-tooltip>
              <el-tooltip
                v-if="scope.row.status && scope.row.status.code!='LOCKED' && scope.row.status.code!='CLOSED'"
                class="item"
                effect="dark"
                content="锁定"
                placement="top"
                :open-delay="300"
              >
                <i @click="lockOrder($event, scope.row)" class="el-icon-lock"></i>
              </el-tooltip>
              <el-tooltip
                v-else-if="scope.row.status && scope.row.status.code=='LOCKED'"
                class="item"
                effect="dark"
                content="解锁"
                placement="top"
                :open-delay="300"
              >
                <i @click="unlockOrder($event, scope.row)" class="el-icon-unlock"></i>
              </el-tooltip>
              <el-tooltip
                v-else-if="scope.row.status && scope.row.status.code=='CLOSED'"
                class="item"
                effect="dark"
                content="重新打开"
                placement="top"
                :open-delay="300"
              >
                <i @click="reopenOrder($event, scope.row)" class="iconfont icon-chongqi"></i>
              </el-tooltip>
              <el-tooltip
                v-if="scope.row.status && scope.row.status.code!='CLOSED'"
                class="item"
                effect="dark"
                content="交接"
                placement="top"
                :open-delay="300"
              >
                <i
                  @click="handover($event, scope.row)"
                  class="iconfont icon-jiaojie"
                ></i>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
        <pagination
          :pagination="pagination"
          @currentChange="currentChange"
          @sizeChange="sizeChange"
          @refreshBtn="getCartonOrderSearch"
        ></pagination>
      </div>
      <div class="rightContent" v-else>
        <detailPage
          ref="detailPage"
          v-if="cutDetail == 'detail'"
          :tabPaneValue="tabPaneValue"
        ></detailPage>
        <devicesPage
          ref="devicesPage"
          v-else-if="cutDetail == 'devices'"
          :tabPaneValue="tabPaneValue"
          :tabPaneData="tabPaneData"
          :devicesSearchForm="devicesSearchForm"
        ></devicesPage>
        <div class="chartView" v-else-if="cutDetail == 'status'">
          <div class="echartBtn">
            <el-button
              :type="proStatus == '产品状态' ? 'primary' : ''"
              size="small"
              @click="cutProStatus('产品状态')"
              >产品状态</el-button
            >
            <el-button
              :type="proStatus == '工单状态' ? 'primary' : ''"
              size="small"
              @click="cutProStatus('工单状态')"
              >工单状态</el-button
            >
            <el-button
              :type="proStatus == '工序状态' ? 'primary' : ''"
              size="small"
              @click="cutProStatus('工序状态')"
              >工序状态</el-button
            >
          </div>
          <div
            v-if="proStatus == '工序状态'"
            class="myEchart"
            ref="workStationEchart"
            key="workStationEchart"
          ></div>
          <div
            v-else-if="proStatus == '工单状态'"
            class="myEchart"
            ref="orderEchart"
            key="orderEchart"
          ></div>
          <div
            v-else-if="proStatus == '产品状态'"
            class="myEchart"
            ref="productEchart"
            key="productEchart"
          ></div>
        </div>
        <processPage
          ref="processPage"
          v-else-if="cutDetail == 'process'"
          :tabPaneValue="tabPaneValue"
          :tabPaneData="tabPaneData"
        ></processPage>
        <QcCheckListPage
          ref="QcCheckListPage"
          v-else-if="cutDetail == 'QcCheckList'"
          :tabPaneValue="tabPaneValue"
          :inspectionForm="inspectionForm"
        ></QcCheckListPage>
        <ProLogPage
          ref="ProLogPage"
          v-else-if="cutDetail == 'proLog'"
          :tabPaneValue="tabPaneValue"
          :proLogForm="proLogForm"
        ></ProLogPage>
      </div>
    </div>
    <myDialog
      ref="myDialog"
      :title="dialogTitle"
      @submitData="submitData"
      @dialogClose="dialogClose"
      :width=winWidth
    >
      <template slot="content">
        <el-form
          ref="dialogForm"
          :model="dialogForm"
          :rules="dialogRules"
          :label-width="labelWidth"
        >
        <div v-if="dialogTitle == '交接包装工单'" key="pe">
            <el-form-item
              label="新所有者："
              size="small"
              prop="userId"
            >
            <el-select
              v-model="dialogForm.userId"
              placeholder="选择新所有者"
              filterable
              clearable
              class="hiddenSelectDropdown"
              :popper-append-to-body="false"
              @visible-change="
                selectVisible($event, 'user', '员工选择', 'dialogForm')
              "
            >
              <el-option
                v-for="(item, index) in pullDownData.userList"
                :key="index"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
            </el-form-item>
          </div>
          <div v-else>
            <el-divider>工单</el-divider>
            <el-form-item
              label="包装工单"
              size="small"
              prop="orderNumber"
              class="inlineItem"
            >
              <el-input
                v-model="dialogForm.orderNumber"
                placeholder="包装工单号"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item
              label="客户"
              size="small"
              prop="customerId"
              class="inlineItem"
            >
              <el-select
                v-model="dialogForm.customerId"
                placeholder="选择客户名称"
                filterable
                clearable
                @change="addCustomerChange"
              >
                <el-option
                  v-for="(item, index) in pullDownData.customerList"
                  :key="index"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="总数量"
              size="small"
              prop="quantity"
              class="inlineItem"
            >
              <el-input-number
                v-model="dialogForm.quantity"
                :min="1"
                :precision="0"
                placeholder="包装单裸机总数"
                :controls="false"
              ></el-input-number>
            </el-form-item>
            <el-form-item
              label="组装工单"
              size="small"
              prop="productionOrderIds"
              class="inlineItem"
            >
              <el-select v-model="dialogForm.productionOrderIds"
                placeholder="选择组装工单" filterable clearable class="hiddenSelectDropdown"
                :popper-append-to-body="false" @visible-change="selectVisible($event, 'productionOrder', '组装工单多选')"
                multiple collapse-tags>
                <el-option v-for="(item, index) in pullDownData.addProductionOrderList"
                  :key="index" :label="item.orderNumber" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="成品编码" size="small" prop="itemCode" class="inlineItem">
              <el-input v-model="dialogForm.itemCode" placeholder="ERP里对应的成品编码" clearable></el-input>
            </el-form-item>
            <el-form-item label="备注" size="small" prop="notes" class="inlineItem">
              <el-input v-model="dialogForm.notes" placeholder="黑色+XX颜色" clearable></el-input>
            </el-form-item>
            <el-divider>内箱</el-divider>
            <el-form-item label="包装规格" size="small" prop="inner.pack" class="inlineItem">
              <el-input-number v-model="dialogForm.inner.pack"
                :min="0" :precision="0" placeholder="套装填，不是套装不要填！！！" :controls="false"
              ></el-input-number>
            </el-form-item>
            <el-form-item label="起始箱号" size="small" prop="innerStartIndex" class="inlineItem">
              <el-input-number
                v-model="dialogForm.inner.startIndex"
                :min="1" :precision="0" placeholder="默认从1开始" :controls="false"
              ></el-input-number>
            </el-form-item>
            <el-form-item label="混装比例" size="small" prop="innerScale" class="inlineItem">
              <el-select v-model="dialogForm.inner.scale" placeholder="选择混装比例" filterable>
                <el-option v-for="(item, index) in pullDownData.cartonScaleList"
                  :key="index" :label="item.title" :value="item.code">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="箱号模板" size="small" class="inlineItem">
              <el-input v-model.trim="dialogForm.inner.snTemplate"
                placeholder="箱号SN的模板,如AN${yyMMdd}%03d" clearable></el-input>
            </el-form-item>
            <el-divider>外箱</el-divider>
            <el-form-item label="包装规格" size="small" prop="outer.pack" class="inlineItem">
              <el-input-number v-model="dialogForm.outer.pack"
                :min="1" :precision="0" placeholder="每个包装单位的裸机数量" :controls="false"></el-input-number>
            </el-form-item>
            <el-form-item
              label="起始箱号"
              size="small"
              prop="outerStartIndex"
              class="inlineItem"
            >
              <el-input-number
                v-model="dialogForm.outer.startIndex"
                :min="1"
                :precision="0"
                placeholder="默认从1开始"
                :controls="false"
              ></el-input-number>
            </el-form-item>
            <el-form-item
              label="混装比例"
              size="small"
              prop="outerScale"
              class="inlineItem"
            >
              <el-select
                v-model="dialogForm.outer.scale"
                placeholder="选择混装比例"
                filterable
              >
                <el-option
                  v-for="(item, index) in pullDownData.cartonScaleList"
                  :key="index"
                  :label="item.title"
                  :value="item.code"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="箱号模板" size="small" class="inlineItem">
              <el-input
                v-model.trim="dialogForm.outer.snTemplate"
                placeholder="箱号SN的模板,如AN${yyMMdd}%03d"
                clearable
              ></el-input>
            </el-form-item>
            <el-divider id="__oqc">栈板/OQC批次</el-divider>
            <el-form-item
              label="栈板规格"
              size="small"
              prop="pallet.pack"
              class="inlineItem"
            >
              <el-input-number
                v-model="dialogForm.pallet.pack"
                :min="1"
                :precision="0"
                placeholder="每个栈板单位的裸机数量"
                :controls="false"
              ></el-input-number>
            </el-form-item>
            <el-form-item
              label="起始栈板号"
              size="small"
              prop="pallet.startIndex"
              class="inlineItem"
            >
              <el-input-number
                v-model="dialogForm.pallet.startIndex"
                :min="1"
                :precision="0"
                placeholder="默认从1开始"
                :controls="false"
              ></el-input-number>
            </el-form-item>
            <el-form-item
              label="混装比例"
              size="small"
              prop="pallet.scale"
              class="inlineItem"
            >
              <el-select
                v-model="dialogForm.pallet.scale"
                placeholder="选择混装比例"
                filterable
              >
                <el-option
                  v-for="(item, index) in pullDownData.cartonScaleList"
                  :key="index"
                  :label="item.title"
                  :value="item.code"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="栈板号模板" size="small" class="inlineItem">
              <el-input
                v-model.trim="dialogForm.pallet.snTemplate"
                placeholder="栈板号SN的模板,如AN${yyMMdd}%03d"
                clearable
              ></el-input>
            </el-form-item>
          </div>
        </el-form>
      </template>
    </myDialog>
    <myDialog
      ref="unbindDialog"
      :title="dialogTitle"
      @submitData="unbindCtnSubmit"
      @dialogClose="addDeviceClose"
      width="450px"
    >
      <template slot="content">
        <el-form
          ref="addDeviceForm"
          :model="addDeviceForm"
          :rules="addDeviceRules"
          :label-width="labelWidth"
        >
          <el-form-item v-if="dialogTitle=='移除SN'" label="SN列表：" size="small" prop="sn">
            <el-input
              v-model="addDeviceForm.sn"
              type="textarea"
              :autosize="{ minRows: 5, maxRows: 20 }"
              placeholder="批量移除SN，一行一个。"
              resize="none"
            ></el-input>
          </el-form-item>
          <el-form-item v-else label="箱号列表：" size="small" prop="sn">
            <el-input
              v-model="addDeviceForm.sn"
              type="textarea"
              :autosize="{ minRows: 5, maxRows: 20 }"
              placeholder="支持3种格式：每行一个箱号；用逗号分隔的零散箱号(1,3,5)；用&连接的连续箱号(5&10)。负数箱号代表重置回【待生产】，否则解绑后回上一站。"
              resize="none"
            ></el-input>
          </el-form-item>
        </el-form>
      </template>
    </myDialog>
    <myDialog
      ref="addDeviceDialog"
      title="返工SN"
      @submitData="reworkSubmit"
      @dialogClose="addDeviceClose"
      width="450px"
    >
      <template slot="content">
        <el-form
          ref="addDeviceForm"
          :model="addDeviceForm"
          :rules="addDeviceRules"
          :label-width="labelWidth"
        >          
          <el-form-item label="SN列表：" size="small" prop="sn">
            <el-input
              v-model="addDeviceForm.sn"
              type="textarea"
              :autosize="{ minRows: 5, maxRows: 20 }"
              placeholder="SN格式：每行一个SN。SN将被返回到【待生产】的状态"
              resize="none"
              @input="addDeviceSNInput"
            ></el-input>
          </el-form-item>
        </el-form>
      </template>
    </myDialog>
    <orderTableSelect
      ref="orderTableSelect"
      @orderTableSubmit="orderTableSubmit"
    ></orderTableSelect>
  </div>
</template>

<script>
import pagination from "@/components/pagination.vue";
import myDialog from "@/components/myDialog.vue";
import * as echarts from "echarts";
import orderTableSelect from "@/components/orderTableSelect.vue";
import detailPage from "./components/detailPage.vue";
import devicesPage from "./components/devicesPage.vue";
import processPage from "./components/processPage.vue";
import QcCheckListPage from "./components/QcCheckListPage.vue";
import ProLogPage from "./components/logsPage.vue";
import {  
  apiCartonOrderClose,
  apiCartonOrderStart,
  apiCartonOrderSearch,
  apiCartonOrderAdd,
  apiCartonOrderWorkStation,
  apiCartonOrderOrder,
  apiCartonByDevice,
  apiCustomerList,
  apiCartonScaleList,
  apiWorkStationList,
  apiCartonSopList,
  apiOrderStatusList,
  apiCartonOrderPause,
  apiCartonOrderLock,
  apiCartonOrderUnlock,
  apiCartonOrderReopen,
  apiHandoverOrder,
  apiCartonOrderRemoveUnpacked,
  apiReworkByCartonOrder,
  apiMultipleUnbindInnerCarton,
  apiMultipleUnbindOuterCarton,
  apiCartonOrderRemoveDevices
} from "@/api/cartonOrder.js";

import { apiFactoryOrgShow } from "@/api/productSystem.js";
export default {
  lastModuleConfig: { modulePath: "/homePage/cartonOrder" },
  components: {
    pagination,
    myDialog,
    orderTableSelect,
    detailPage,
    devicesPage,
    processPage,
    ProLogPage,
    QcCheckListPage,
  },
  data() {
    return {
      dialogTitle: "",
      tabPaneList: [],
      tabPaneData: {},
      tabPaneValue: "first",
      isMoreSearch: false,
      searchConditionForm: {},
      devicesSearchForm: {},
      inspectionForm:{},
      proLogForm: {},
      isShowTips: true,
      pullDownData: {
        customerList: [],
        orderStatusList: [],
        // 查询中的组装工单列表
        productionOrderList: [],
        customerOrderList: [],
        // 产品列表
        devicesCartonTypeList: [],
        devicesProductionList: [],
        productionOrderStatusList: [],
        cartonScaleList: [],
        // 新建中的组装工单列表
        addProductionOrderList: [],
        // 生产工序--工序下拉
        workStationList: [],
        // 工序-上一工序 && 日志-工序
        cartonSopList: [],
        // 日志--线体
        factoryOrgData: [],
        // 日志--员工
        userList: [],
      },
      tableData: [],
      desc: undefined,
      orderBy: [],
      pagination: {
        currentPage: 1,
        pageSize: 40,
        total: 102,
        beginIndex: 1,
        endIndex: 10,
      },
      cutDetail: "detail",
      detailData: {}, // 详情数据
      proStatus: "产品状态",
      pieColor: [
        "#dd6b66",
        "#759aa0",
        "#e69d87",
        "#d48265",
        "#91c7ae",
        "#749f83",
        "#ca8622",
        "#bda29a",
        "#6e7074",
        "#546570",
        "#c4ccd3",
      ],
      dialogForm: {
        inner: {},
        outer: {},
        pallet: {},
        productionOrderIds: [],
      },      
      addDeviceForm: {},
      addDeviceRules: {
        sn: [{ required: true, message: "SN不能为空！", trigger: "blur" }],
      },
      dialogRules: {
        userId: [
          { required: true, message: "工单的新所有者不能为空！", trigger: "change" },
        ],
        customerId: [
          { required: true, message: "客户名称不能为空！", trigger: "change" },
        ],
        orderNumber: [
          { required: true, message: "包装工单不能为空！", trigger: "blur" },
          {
            min: 4,
            max: 64,
            message: "长度在 4 到 64 个字符！",
            trigger: "change",
          },
        ],
        quantity: [
          { required: true, message: "包装数量不能为空！", trigger: "blur" },
        ],
        // "inner.pack": [
        //   { required: true, message: "包装规格不能为空！", trigger: "blur" },
        //   { required: true, message: "包装规格不能为空！", trigger: "change" },
        // ],
        "outer.pack": [
          { required: true, message: "包装规格不能为空！", trigger: "blur" },
        ],
        "pallet.pack": [
          { required: true, message: "栈板规格不能为空！", trigger: "blur" },
        ],
        itemCode: [{ required: true, message: "成品编码不能为空！", trigger: "blur" }],
        notes: [{ required: true, message: "备注不能为空！", trigger: "blur" }],
      },
      labelWidth: this.$store.state.labelWidth,
      winWidth:"600px"
    };
  },
  watch: {
    tabPaneValue: function (newVal) {
      this.$moreSearchStyle();
      if (newVal == "first") {
        this.getCartonOrderSearch();
      } else {
        this.$nextTick(() => {
          this.tabPaneList.forEach((item) => {
            if (item.id == newVal) {
              this.tabPaneData = item;
            }
          });
          this.$set(this.devicesSearchForm, "productionOrderId", undefined);
          this.$set(this.devicesSearchForm, "customerOrderId", undefined);
          this.$set(this.proLogForm, "workStationId", undefined);
          if (this.cutDetail == "detail") {
            this.$refs.detailPage.getCartonOrderDetail();
          } else if (this.cutDetail == "devices") {
            this.$set(this.devicesSearchForm, "workStationId", undefined);
            this.$refs.devicesPage.pagination.currentPage = 1;
            this.$refs.devicesPage.getCartonOrderDevices().then(() => {
              this.$refs.devicesPage.getCartonTypeList();
              this.$refs.devicesPage.getCartonOrderProductionOrders();
              this.$refs.devicesPage.getProductionOrderStatusList();
            });
          } else if (this.cutDetail == "status") {
            this.cutProStatus(this.proStatus);
          } else if (this.cutDetail == "process") {
            this.$refs.processPage.getCartonSopSearch();
            this.$refs.processPage.getLabelType();
            this.$refs.processPage.getBestOf();
          } else if (this.cutDetail == "proLog") {
            this.$refs.ProLogPage.getFactoryLogSearch(
              "",
              false,
              this.getCartonSopList
            );
          }else if (this.cutDetail == "QcCheckList") {
            this.$refs.QcCheckListPage.getQcCheckListSearch();
          }
        });
      }
    },
  },
  computed: {
  },
  methods: {
    unbindDialog(val) {
      this.dialogTitle=val;
      this.$refs.unbindDialog.dialogVisible = true;
    },
    rework() {
      this.$refs.addDeviceDialog.dialogVisible = true;
    },
    addDeviceSNInput(val) {
      let newVal = val.replace(/[^a-zA-Z\d\n]/g, "");
      this.$set(this.$refs.addDeviceForm, "sn", newVal);
    },
    async unbindCtnSubmit() {
      this.$refs.addDeviceForm.validate(async (valid) => {
        if (valid) {
          let res;
          if (this.dialogTitle=='移除SN') {
            res = await apiCartonOrderRemoveDevices({
              id: this.tabPaneValue,
              sn: this.addDeviceForm.sn.split("\n").filter((item) => {
                if (item != 0) {
                  return true;
                }
              }),
              orderType: 1
            });
          } else if (this.dialogTitle==='解绑外箱') {
            res = await apiMultipleUnbindOuterCarton({
              id: this.tabPaneValue,
              sn: this.addDeviceForm.sn.split("\n").filter((item) => {
                if (item != 0) {
                  return true;
                }
              }),
              orderType: 1
            });
          } else {
            res = await apiMultipleUnbindInnerCarton({
              id: this.tabPaneValue,
              sn: this.addDeviceForm.sn.split("\n").filter((item) => {
                if (item != 0) {
                  return true;
                }
              }),
              orderType: 1
            });
          }
          if (res.code == 0) {
            this.$refs.unbindDialog.dialogVisible = false;
            this.$message({
              message: res.msg,
              type: "success",
            });            
            this.$refs.devicesPage.pagination.currentPage = 1;
            this.$refs.devicesPage.getCartonOrderDevices();
          }
        }
      });
    },
    reworkSubmit() {
      this.$refs.addDeviceForm.validate(async (valid) => {
        if (valid) {
          let res = await apiReworkByCartonOrder({
            id: this.tabPaneValue,
            sn: this.addDeviceForm.sn.split("\n").filter((item) => {
              if (item != 0) {
                return true;
              }
            }),
            orderType: 1
          });
          if (res.code == 0) {
            this.$refs.addDeviceDialog.dialogVisible = false;
            this.$message({
              message: res.msg,
              type: "success",
            });            
            this.$refs.devicesPage.pagination.currentPage = 1;
            this.$refs.devicesPage.getCartonOrderDevices();
          }
        } else {
          return false;
        }
      });
    },    
    addDeviceClose() {
      this.$refs.addDeviceForm.resetFields();
      this.addDeviceForm = {};
    },
    removeUnpacked() {
      const h = this.$createElement;
      this.$msgbox({
        title: `移除未封箱`,
        message: h("div", null, [
          h(
            "span",
            null,
            `请输入工单号:【`
          ),
          h("i", { style: "color: var(--themeColor)" }, this.tabPaneData.orderNumber),
          h("span", null, `】以便确认将【未封箱的SN】移回组装工单`),
        ]),
        showCancelButton: true,
        confirmButtonText: `确认`,
        cancelButtonText: "取消",
        closeOnClickModal: false,
        showInput: true,
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            if (instance.inputValue == this.tabPaneData.orderNumber) {
              done();
            } else {
              this.$message({
                type: "warning",
                message: `输入错误，请重新输入或取消！`,
              });
            }
          } else {
            done();
          }
        },
      }).then(async () => {
        const res = await apiCartonOrderRemoveUnpacked({          
            id: this.tabPaneData.id,
        });
        if (res.code == 0) {
          this.cutDetailChange('status');
          this.$message({
            message: res.msg,
            type: "success",
          });
        }
      });
    },
    // 交接工单
    handover(e, row) {
      this.dialogTitle = "交接包装工单";
      this.winWidth="450px";
      this.$refs.myDialog.dialogVisible = true;
      this.dialogForm = {
        id: row.id
      };
    },    
    onlyMyChange() {
        this.getCartonOrderSearch();
    },
    pauseOrder(e, row, src) {
      e.target.blur();
      const h = this.$createElement;
      this.$msgbox({
        title: `警告：暂停后产线将暂时无法生产此工单！`,
        message: h("div", null, [
          h(
            "span",
            null,
            `请输入工单号:【`
          ),
          h("i", { style: "color: var(--themeColor)" }, row.orderNumber),
          h("span", null, `】以确认锁定！`),
        ]),
        showCancelButton: true,
        confirmButtonText: `确认`,
        cancelButtonText: "取消",
        closeOnClickModal: false,
        showInput: true,
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            if (instance.inputValue == row.orderNumber) {
              done();
            } else {
              this.$message({
                type: "warning",
                message: `输入错误，请重新输入或取消！`,
              });
            }
          } else {
            done();
          }
        },
      }).then(async () => {
        const res = await apiCartonOrderPause({
          id: row.id
        });
        if (res.code == 0) {
          if (src) {
            this.$refs.detailPage.getCartonOrderDetail();
          } else {
            this.pagination.currentPage = 1;
            this.getCartonOrderSearch();
          }
          this.$message({
            type: "success",
            message: res.msg
          });
        }
      });
    },
    // 锁定工单
    lockOrder(e, row) {
      e.target.blur();
      const h = this.$createElement;
      this.$msgbox({
        title: `警告：锁定后不能继续生产！`,
        message: h("div", null, [
          h(
            "span",
            null,
            `请输入工单号:【`
          ),
          h("i", { style: "color: var(--themeColor)" }, row.orderNumber),
          h("span", null, `】以确认锁定！`),
        ]),
        showCancelButton: true,
        confirmButtonText: `确认`,
        cancelButtonText: "取消",
        closeOnClickModal: false,
        showInput: true,
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            if (instance.inputValue == row.orderNumber) {
              done();
            } else {
              this.$message({
                type: "warning",
                message: `输入错误，请重新输入或取消！`,
              });
            }
          } else {
            done();
          }
        },
      }).then(async () => {
        const res = await apiCartonOrderLock({
          id: row.id
        });
        if (res.code == 0) {
          this.pagination.currentPage = 1;
          this.getCartonOrderSearch();
          this.$message({
            type: "success",
            message: "包装工单锁定成功，该工单将暂停生产！"
          });
        }
      });
    },
    
    // 重新打开工单
    reopenOrder(e, row) {
      e.target.blur();
      const h = this.$createElement;
      this.$msgbox({
        title: `提示：重新将工单设置为“待生产”状态！`,
        message: h("div", null, [
          h(
            "span",
            null,
            `请输入工单号:【`
          ),
          h("i", { style: "color: var(--themeColor)" }, row.orderNumber),
          h("span", null, `】以确认重新打开工单！`),
        ]),
        showCancelButton: true,
        confirmButtonText: `确认`,
        cancelButtonText: "取消",
        closeOnClickModal: false,
        showInput: true,
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            if (instance.inputValue == row.orderNumber) {
              done();
            } else {
              this.$message({
                type: "warning",
                message: `输入错误，请重新输入或取消！`,
              });
            }
          } else {
            done();
          }
        },
      }).then(async () => {
        const res = await apiCartonOrderReopen({
          id: row.id
        });
        if (res.code == 0) {
          this.pagination.currentPage = 1;
          this.getCartonOrderSearch();
          this.$message({
            type: "success",
            message: "包装工单重新打开成功！"
          });
        }
      });
    },
    // 解锁工单
    unlockOrder(e, row) {
      e.target.blur();
      const h = this.$createElement;
      this.$msgbox({
        title: `温馨提示：解锁后需要重新开始生产！`,
        message: h("div", null, [
          h(
            "span",
            null,
            `请输入工单号:【`
          ),
          h("i", { style: "color: var(--themeColor)" }, row.orderNumber),
          h("span", null, `】以确认解锁！`),
        ]),
        showCancelButton: true,
        confirmButtonText: `确认`,
        cancelButtonText: "取消",
        closeOnClickModal: false,
        showInput: true,
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            if (instance.inputValue == row.orderNumber) {
              done();
            } else {
              this.$message({
                type: "warning",
                message: `输入错误，请重新输入或取消！`,
              });
            }
          } else {
            done();
          }
        },
      }).then(async () => {
        const res = await apiCartonOrderUnlock({
          id: row.id
        });
        if (res.code == 0) {
          this.pagination.currentPage = 1;
          this.getCartonOrderSearch();
          this.$message({
            type: "success",
            message: "包装工单解锁成功，请重新【开始生产】！"
          });
        }
      });

    },
    // 工单状态下拉
    async getOrderStatusList() {
      const res = await apiOrderStatusList();
      if (res.code == 0) {
        this.pullDownData.orderStatusList = res.data;
      }
    },
    // 切换一级面板
    tabPaneClick(tab) {
      this.tabPaneValue = tab.name;
    },
    // 关闭一级面板
    closeTabPane(index) {
      if (this.tabPaneList[index].id == this.tabPaneValue) {
        if (index > 0) {
          this.tabPaneValue = this.tabPaneList[index - 1].id;
        } else {
          this.tabPaneValue = "first";
        }
      }
      this.tabPaneList.splice(index, 1);
    },
    // 切换详情-二级面板
    cutDetailChange(value) {
      this.cutDetail = value;
      this.$moreSearchStyle();
      this.$nextTick(() => {
        if (value == "detail") {
          this.$refs.detailPage.getCartonOrderDetail();
        } else if (value == "devices") {
          this.$refs.devicesPage.getCartonOrderDevices().then(() => {
            this.$refs.devicesPage.getCartonTypeList();
            this.$refs.devicesPage.getCartonOrderProductionOrders();
            this.$refs.devicesPage.getProductionOrderStatusList();
          });
        } else if (this.cutDetail == "status") {
          this.cutProStatus(this.proStatus);
        } else if (this.cutDetail == "process") {
          this.$refs.processPage.getCartonSopSearch();
          this.$refs.processPage.getLabelType();
          this.$refs.processPage.getBestOf();
        } else if (this.cutDetail == "proLog") {
          this.$refs.ProLogPage.getFactoryLogSearch("", false, this.getCartonSopList);
        }else if (this.cutDetail == "QcCheckList") {
          this.$refs.QcCheckListPage.getQcCheckListSearch();
        }
      });
    },
    // 表格数据
    async getCartonOrderSearch(remove, callback) {
      if (!(remove == "noRemove")) {
        this.tableData = [];
      }
      const res = await apiCartonOrderSearch({
        ...this.searchConditionForm,
        pageNum: this.pagination.currentPage,
        pageSize: this.pagination.pageSize,
        desc: this.desc,
        orderBy: this.orderBy,
      });
      // console.log(res);
      if (res.code == 0) {
        this.tableData = res.data;
        this.pagination.total = res.total;
        this.pagination.beginIndex = res.beginIndex;
        this.pagination.endIndex = res.endIndex;
        if (callback) callback();
      }
    },
    // 生产状态--切换图表
    cutProStatus(value, callback) {
      this.proStatus = value;
      if (value == "工序状态") {
        this.getCartonOrderWorkStation(callback);
      } else if (value == "工单状态") {
        this.getCartonOrderOrder(callback);
      } else if (value == "产品状态") {
        this.getCartonByDevice(callback);
      }
    },
    // 工序状态(柱状图)
    async getCartonOrderWorkStation(callback) {
      const res = await apiCartonOrderWorkStation({
        id: this.tabPaneValue,
      });
      if (res.code == 0) {
        let workStationEchart = echarts.init(this.$refs.workStationEchart);
        workStationEchart.clear();
        if (!res.data.items.length) {
          this.$message({
            type: "warning",
            message: "查询数据为空！",
          });
        }
        let option = {};
        let nameList = [],
          countList = [];
        res.data.items.forEach((item) => {
          nameList.push(item.workStation);
          countList.push(item.value);
        });
        option = {
          backgroundColor: "#fff",
          title: {
            text: "总数量：" + res.data.count + "PCS",
            left: "center",
            textStyle: {
              color: "#303133",
            },
          },
          xAxis: {
            type: "category",
            data: nameList,
            axisLine: {
              lineStyle: {
                color: "#303133",
              },
            },
            axisTick: {
              alignWithLabel: true,
            },
          },
          yAxis: {
            type: "value",
            splitLine: {
              lineStyle: {
                type: "dashed",
              },
            },
            axisLine: {
              lineStyle: {
                color: "#303133",
              },
            },
          },
          tooltip: {
            show: true,
            trigger: "axis",
            axisPointer: {
              // 坐标轴指示器，坐标轴触发有效
              type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
            },
          },
          series: [
            {
              data: countList,
              type: "bar",
              barWidth: 80,
            },
          ],
          // backgroundColor: "#333",
        };
        workStationEchart.setOption(option);
        if (callback) callback();
      }
    },
    // 工单状态(饼图)
    async getCartonOrderOrder(callback) {
      const res = await apiCartonOrderOrder({
        id: this.tabPaneValue,
      });
      // console.log(res);
      if (res.code == 0) {
        let allCount = 0;
        res.data.items.forEach((item) => (allCount += item.value));
        let legendData = res.data.items.map(
          (item) => item.orderNum + "：" + item.value + "PCS"
        );
        let seriesData = res.data.items.map((item) => {
          return {
            value: item.value,
            name: item.orderNum + "：" + item.value + "PCS",
            tooltip: {
              formatter: "{a}<br />{b}：{d}%",
            },
          };
        });
        let orderEchart = echarts.init(this.$refs.orderEchart);
        orderEchart.clear();
        let option = {
          backgroundColor: "#fff",
          color: this.pieColor,
          title: {
            text: "总数量：" + allCount + "PCS",
            left: "center",
            textStyle: {
              color: "#303133",
            },
          },
          tooltip: {
            trigger: "item",
            formatter: "{a} <br/>{b} : {c} ({d}%)",
          },
          legend: {
            orient: "vertical",
            left: "left",
            top: 30,
            data: legendData,
            textStyle: {
              color: "#303133",
            },
          },
          series: [
            {
              name: "状态",
              type: "pie",
              radius: "55%",
              center: ["50%", "60%"],
              data: seriesData,
              label: {
                color: "rgba(0, 0, 0)",
              },
              emphasis: {
                itemStyle: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: "rgba(0, 0, 0, 0.5)",
                },
              },
            },
          ],
          // backgroundColor: "rgba(0, 0, 0, 0.5)",
        };
        orderEchart.setOption(option);
        if (callback) callback();
      }
    },
    // 产品状态(饼图)
    async getCartonByDevice(callback) {
      const res = await apiCartonByDevice({
        id: this.tabPaneValue,
      });
      // console.log(res);
      if (res.code == 0) {
        let legendData = res.data.items.map(
          (item) => item.workStation + "：" + item.count_device + "PCS"
        );
        let seriesData = res.data.items.map((item) => {
          return {
            value: item.count_device,
            name: item.workStation + "：" + item.count_device + "PCS",
            tooltip: {
              formatter: "{a}<br />{b}：{d}%",
            },
          };
        });
        let productEchart = echarts.init(this.$refs.productEchart);
        productEchart.clear();
        let option = {
          backgroundColor: "#fff",
          color: this.pieColor,
          title: {
            text: "总数量：" + res.data.count + "PCS",
            left: "center",
            textStyle: {
              color: "#303133",
            },
          },
          tooltip: {
            trigger: "item",
            formatter: "{a} <br/>{b} : {c} ({d}%)",
          },
          legend: {
            orient: "vertical",
            left: "left",
            top: 30,
            data: legendData,
            textStyle: {
              color: "#303133",
            },
          },
          series: [
            {
              name: "状态",
              type: "pie",
              radius: "55%",
              center: ["50%", "60%"],
              data: seriesData,
              label: {
                color: "rgba(0, 0, 0)",
              },
              emphasis: {
                itemStyle: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: "rgba(0, 0, 0, 0.5)",
                },
              },
            },
          ],
        };
        productEchart.setOption(option);
        if (callback) callback();
      }
    },
    // 更多查询
    moreSearchBtn() {
      this.isMoreSearch = !this.isMoreSearch;
      this.$moreSearchStyle();
    },
    // 新建包装工单
    addNewBtn() {
      this.dialogTitle = "新建包装工单";
      this.winWidth="600px";
      this.$refs.myDialog.dialogVisible = true;
      this.$set(this.dialogForm.inner, "scale", this.pullDownData.cartonScaleList[0].code);
      this.$set(this.dialogForm.outer, "scale", this.pullDownData.cartonScaleList[0].code);
      this.$set(this.dialogForm.pallet, "scale", this.pullDownData.cartonScaleList[0].code);
    },
    // 确认新建
    submitData(title) {
      this.$refs.dialogForm.validate(async (valid) => {
        if (valid) {
          if (title == "新建包装工单") {
            const res = await apiCartonOrderAdd({
              ...this.dialogForm,
            });
            if (res.code == 0) {
              this.$refs.myDialog.dialogVisible = false;
              this.pagination.currentPage = 1;
              this.getCartonOrderSearch();
              this.$message({
                message: "新建成功",
                type: "success",
              });
            }
          } else if (title == "交接包装工单") {
            const res = await apiHandoverOrder({
              ...this.dialogForm
            });
            if (res.code == 0) {
              this.$refs.myDialog.dialogVisible = false;
              this.getCartonOrderSearch();
              this.$message({
                message: "工单所有者交接成功",
                type: "success",
              });
            }
          }
        } else {
          return false;
        }
      });
    },
    // 关闭对话框
    dialogClose() {
      this.$refs.dialogForm.resetFields();
      this.dialogForm = {
        inner: {},
        outer: {},
        pallet: {},
        productionOrderIds: [],
      };
    },
    // 清除查询
    onClear() {
      if (this.tabPaneValue == "first") {
        this.searchConditionForm = {};
        this.pullDownData.productList = [];
        this.pagination.currentPage = 1;
        this.getCartonOrderSearch();
      } else {
        if (this.cutDetail == "devices") {
          this.devicesSearchForm = {};
          this.$refs.devicesPage.pagination.currentPage = 1;
          // props传参数据有延迟，需要nextTick延迟调用数据
          this.$nextTick(() => {
            this.$refs.devicesPage.getCartonOrderDevices();
          });
        } else if (this.cutDetail == "proLog") {
          this.proLogForm = {};
          this.$refs.ProLogPage.pagination.currentPage = 1;
          this.$nextTick(() => {
            this.$refs.ProLogPage.getFactoryLogSearch();
          });
        } else if (this.cutDetail == "QcCheckList") {
          this.inspectionForm={};
          this.$refs.QcCheckListPage.pagination.currentPage=1;
          this.$nextTick(() => {
           this.$refs.QcCheckListPage.getQcCheckListSearch();
          });
          
        }
      }
    },
    // 确认查询
    onSearch(value) {
      if (this.tabPaneValue == "first") {
        this.pagination.currentPage = 1;
        this.getCartonOrderSearch();
      } else {
        if (this.cutDetail == "devices") {
          this.devicesSearchForm.like = value;
          this.$refs.devicesPage.pagination.currentPage = 1;
          this.$refs.devicesPage.getCartonOrderDevices();
        } else if (this.cutDetail == "proLog") {
          this.$refs.ProLogPage.pagination.currentPage = 1;
          this.$refs.ProLogPage.getFactoryLogSearch(value ? "noRemove" : "", value);
        } else if (this.cutDetail == "QcCheckList") {
          this.$refs.QcCheckListPage.pagination.currentPage = 1;
          this.$refs.QcCheckListPage.getQcCheckListSearch();
        }
      }
    },
    // 产品列表表格导出
    tableExport() {
      this.$refs.devicesPage.tableExport();
    },
    // 当前工序改变
    workStationChange() {
      setTimeout(() => {
        this.$moreSearchStyle();
      }, 100);
    },
    // 关闭温馨提示
    closeTips() {
      this.isShowTips = false;
      this.$moreSearchStyle();
    },
    // 工单详情开始生产 && 结单
    detailStatusBtn() {
      if (this.detailData.status.code=='PRODUCTION') {
        // console.log("结单")
        this.closeOrder(this.tabPaneData);
      } else if (this.detailData.status.code=='READY') {
        // console.log("开始生产")
        this.startOrder(this.tabPaneData);
      }
    },
    // 开始生产
    startOrder(row, msg = `现在开始生产：${row.orderNumber} ？`, force) {
      this.$confirm(msg, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        const res = await apiCartonOrderStart({
          id: row.id,
          force,
        });
        if (res.code == 0) {
          this.$refs.detailPage.getCartonOrderDetail();
          this.$message({
            type: "success",
            message: "开始成功",
          });
        } else if (res.code == 1024) {
          setTimeout(() => {
            this.startOrder(row, res.msg, true);
          }, 300);
        }
      });
    },    
    // 结单生产
    closeOrder(row, msg = `确认结单：${row.orderNumber} ？`, force) {
      this.$confirm(msg, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        const res = await apiCartonOrderClose({
          id: row.id,
          force,
        });
        if (res.code == 0) {
          this.$refs.detailPage.getCartonOrderDetail();
          this.$message({
            type: "success",
            message: "结单成功",
          });
        } else if (res.code == 1024) {
          setTimeout(() => {
            this.closeOrder(row, res.msg, true);
          }, 300);
        } else {
          this.$message({
            type: "error",
            message: res.msg,
          });
        }
      });
    },
    // 判断id只能输入数字
    idInputChange(value, formName) {
      this.$set(this[formName], "id", this.$formatPositive(value));
    },
    // 新建工单-客户改变
    addCustomerChange() {
      this.$set(this.dialogForm, "productionOrderIds", []);
      this.$set(this.pullDownData, "addProductionOrderList", []);
    },
    // 查询条件-客户改变
    searchCustomerChange() {
      // this.$set(this.searchConditionForm, "customerOrderId", undefined);
      this.$set(this.searchConditionForm, "productionOrderId", undefined);
    },
    // 查询条件-组装工单
    selectVisible(value, orderName, labelName, origin) {
      if (value) {
        this.$refs.orderTableSelect.labelName = labelName;
        this.$refs.orderTableSelect.orderName = orderName;
        this.$refs.orderTableSelect.origin = origin;
        if (labelName == "组装工单多选") {
          this.$refs.orderTableSelect.parameter = {
            customerId: this.dialogForm.customerId,
            // 已选择的工单
            selectedRow: this.pullDownData.addProductionOrderList.filter(
              (item) => this.dialogForm.productionOrderIds.includes(item.id)
            ),
          };
        } else {
          this.$refs.orderTableSelect.parameter = {
            customerId: this.searchConditionForm.customerId,
            // customerOrderId: this.searchConditionForm.customerOrderId,
          };
        }
        this.$refs.orderTableSelect.openDialog();
      }
    },
    // 订单表格提交
    orderTableSubmit({ orderName, labelName, selectRow, origin }) {
      if (labelName == "组装工单多选") {
        this.$set(
          this.dialogForm,
          `${orderName + "Ids"}`,
          selectRow.map((item) => item.id)
        );
        this.$set(this.pullDownData, `addProductionOrderList`, selectRow);
      } else {
        this.$set(this[origin], `${orderName + "Id"}`, selectRow.id);
        this.$set(this.pullDownData, `${orderName + "List"}`, [selectRow]);
        // 查询销售订单改变
        if (orderName == "customerOrder") {
          this.$set(this[origin], "productionOrderId", undefined);
        }
      }
    },
    // 查询条件--包装类型改变
    cartonTypeChange() {
      this.$set(this.devicesSearchForm, "ctnIndex", undefined);
      this.$set(this.devicesSearchForm, "ctnSn", undefined);
    },
    // 查询条件--开始日期
    startDateChange(formName) {
      let { startDate, endDate } = this[formName];
      if (startDate > endDate) {
        this[formName].endDate = this[formName].startDate;
      }
    },
    // 查询条件--结束日期
    endDateChange(formName) {
      let { startDate, endDate } = this[formName];
      if (startDate > endDate) {
        this[formName].startDate = this[formName].endDate;
      }
    },
    // 表格数据排序
    sortChange({ prop, order }) {
      this.orderBy[0] = prop;
      if (order == "ascending") {
        this.desc = false;
      } else if (order == "descending") {
        this.desc = true;
      } else {
        this.desc = undefined;
        this.orderBy = [];
      }
      this.getCartonOrderSearch();
    },
    // 页码改变
    currentChange(val) {
      this.pagination.currentPage = val;
      this.getCartonOrderSearch();
    },
    // 页容量改变
    sizeChange(val) {
      this.pagination.currentPage = 1;
      this.pagination.pageSize = val;
      this.getCartonOrderSearch();
    },
    // 表格列包装单号点击
    clickAllowSkip(row) {
      this.tabPaneValue = row.id;
      let tabPaneIds = this.tabPaneList.map((item) => item.id);
      if (tabPaneIds.includes(row.id)) {
        this.tabPaneList.splice(tabPaneIds.indexOf(row.id), 1, row);
      } else {
        this.tabPaneList.push(row);
      }
    },
    // 生产工序--添加工序
    addProcess() {
      this.$refs.processPage.addNewBtn();
    },
    // 客户名称下拉
    async getCustomerList() {
      const res = await apiCustomerList();
      if (res.code == 0) {
        this.pullDownData.customerList = res.data;
      }
    },
    // 混装比例下拉
    async getCartonScaleList() {
      const res = await apiCartonScaleList();
      if (res.code == 0) {
        this.pullDownData.cartonScaleList = res.data;
      }
    },
    // 生产工序-工序下拉
    async getWorkStationList() {
      const res = await apiWorkStationList();
      if (res.code == 0) {
        this.pullDownData.workStationList = res.data;
      }
    },
    // 生产日志-工序
    async getCartonSopList() {
      const res = await apiCartonSopList({
        orderId: this.tabPaneValue,
        all: true
      });
      if (res.code == 0) {
        this.pullDownData.cartonSopList = res.data;
      }
    },
    // 生产日志--线体
    async getFactoryOrg() {
      const res = await apiFactoryOrgShow();
      // console.log(res);
      if (res.code == 0) {
        this.data = res.data;
        this.pullDownData.factoryOrgData = res.data.children;
      }
    },
    // 联级选择器改变时触发
    cascaderChange(val, ref) {
      val && this.$refs[ref].toggleDropDownVisible();
    },
    callback() {
      this.getOrderStatusList();
      this.getCustomerList();
      this.getCartonScaleList();
      this.getWorkStationList();
      this.getFactoryOrg();
    },
  },
  activated() {
    window.onresize = () => {
      document.querySelector(".contentBox").style.top =
        document.querySelector(".header").offsetHeight + "px";
    };
    if (this.tabPaneValue == "first") {
      this.getCartonOrderSearch("", this.callback);
    } else {
      if (this.cutDetail == "detail") {
        this.$refs.detailPage.getCartonOrderDetail(this.callback);
      } else if (this.cutDetail == "devices") {
        this.$refs.devicesPage.getCartonOrderDevices("").then(() => {
          this.callback();
          this.$refs.devicesPage.getCartonTypeList();
          this.$refs.devicesPage.getCartonOrderProductionOrders();
          this.$refs.devicesPage.getProductionOrderStatusList();
        });
      } else if (this.cutDetail == "status") {
        this.cutProStatus(this.proStatus, this.callback);
      } else if (this.cutDetail == "process") {
        this.$refs.processPage.getCartonSopSearch("", this.callback);
        this.$refs.processPage.getLabelType();
        this.$refs.processPage.getBestOf();
      } else if (this.cutDetail == "proLog") {
        this.$refs.ProLogPage.getFactoryLogSearch("", false, this.callback);
      } else if (this.cutDetail == "QcCheckList") {
          this.$refs.QcCheckListPage.getQcCheckListSearch();
      }
    }
  },
  deactivated() {
    window.onresize = null;
  },
};
</script>

<style lang="less" scoped>
.packageOrder {
  .chartView {
    width: 1100px;
    height: 100%;
    margin: 40px auto;
    .echartBtn {
      width: 120px;
      padding-right: 20px;
      float: left;
      button {
        min-width: 68px;
        margin-left: 0;
        margin-bottom: 10px;
      }
    }
    .myEchart {
      float: left;
      width: 900px;
      height: 440px;
      margin: 0 auto;
      border-radius: 5px;
      overflow: hidden;
    }
  }
}
.icon-yiguoqi {
  margin-right: 3px;
  color: #f56c6c
}
.expire {
  color: #f56c6c
}
#__oqc {
  left: 32px;
}
</style>